export default "__VITE_ASSET__D2v1QxEs__"